/* eslint-env es6 */
import React from 'react';
import '../css/Footer.css';
import { useTranslation } from '../store';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="mk-grid">
        <span className="mk-footer-copyright">
          {t('copyright', {year: currentYear})}
        </span>
        <nav id="mk-footer-navigation" className="footer-menu">
          <ul id="menu-footer-menu" className="menu">
            <li className="menu-item">
              <a href="https://hypertec.com/privacy-policy/" target="_blank" rel="privacy-policy noopener noreferrer">
                {t('privacyPolicy')}  
              </a>
            </li>
            <li className="menu-item">
              <a href="https://hypertec.com/terms-of-use/" target="_blank" rel="noopener noreferrer">
                {t('termsOfUse')}
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;